const {Vue, jQuery: $} = window;

import {
	getOptionsDetails,
	getRegionDir,
	convertName
} from "../_utilities";
import { ACTIONS } from "../_actions";
import {store, store$} from "../_config-store";
import { localize } from "../_localize.js";

const truckCab$ = store$
	.map(state => state.truckCab);

const truckModel$ = store$
	.map(state => state.truckModel);

const optionDetails$ = store$
	.map(state => state.optionDetails);

const focusedOption$ = store$
	.map(state => state.focusedOption);

//  v-bind:icon="iconString()"

export const options = {
	template:
	`<figure v-bind:class="classes">
		<span icon v-bind:style="{backgroundColor: color, backgroundImage: !color ? iconUrl : false}" :matrix-key="key"></span>
		<div>
			<label v-if="showLabel()">{{label}} <span v-if="labelHighlight()">{{labelHighlight()}}</span></label>
			<label v-if="subLabel">{{subLabel}}</label>
			<label v-if="tag" class="tag">{{tag}}</label>
			<div v-if="showDisclaimer()">{{showDisclaimer()}}</div>
			<a v-if="details" v-on:click="activateDetails" v-html="local('Details +')"></a>
		</div>
	</figure>`,
	props: ['icon','label','subLabel','interacted','color','selected', 'optionObj', 'option','optionKey','parent','firstOption'],
	subscriptions: function() {
		return {
			truckCab: truckCab$,
			truckModel: truckModel$,
			optionDetails: optionDetails$,
			focusedOption: focusedOption$,
			store: store$
		};
	},
	data() {
		return {
			regionDir: getRegionDir(),
			tags: {},
			local(str){
				return str;
			}
		}
	},
	computed: {
		classes(){
			return _.chain(['interacted','selected','option','color']).map( item => this[item] ? item : false).compact().value().join(' ');
		},
		details(){
			return getOptionsDetails(this.optionDetails,this.truckModel,this.truckCab,this.firstOption || this.optionKey) ? true : false;
		},
		tag(){
			return _.at(this.optionObj,`.option['Label (Web)']`)[0] || false;
			// let tag = this.tags[this.label] || this.tags[this.subLabel];
			// return tag ? tag[this.focusedOption] || tag.default : false;
		},
		key(){
			//return this.optionKey;
			return this.optionKey ? this.optionKey.toLowerCase().split('™').join('').split('®').join('').split(' ').join('-') : false;
		},
		iconUrl(){
			let {mediaHostAddress} = window;
            return this.key ? 'url('+(mediaHostAddress || '') + "/images/region/" + this.regionDir + '/options/' + convertName(this.truckModel) + '/' +  this.key + ".png?auto=format%2Ccompress&fm=jp2%2Cpng" + ')' : false;
		}
	},
	methods: {
		iconString(){
			return this.icon || this.optionClass(this.parent ? this.parent + '-' + (this.subLabel ? this.subLabel : this.label) : this.label);
		},
		showLabel() {
			// This is a Hack!! 
			// Because the data resides on a spreadsheet there is no easy way to accomplish this
			// If we start getting more request for this then we should take the time and build logic on the Options Matrix
			switch (this.optionKey) {
				case 'ldw_dac':
					return culture && culture === 'es-mx' ? false : true;
				default:
					return true;
			}
		},
		labelHighlight(){
			switch(this.optionKey){
				case 'aero_2':
					return this.local('Most Aerodynamic');
				case 'pt_idp':
				case 'trans_dt12':
				case 'alm_on':
					return this.local('Recommended');
			}
			return '';

		},
		optionClass(optionLabel){
			return _.kebabCase(optionLabel).replace('™', '').replace('®', '');
		},
		activateDetails(e){
			e.stopImmediatePropagation();
			store.dispatch({
				type: ACTIONS.ACTIVE_DETAILS_CHANGE,
				data: this.firstOption || this.optionKey,
				// For GTM
				option: this.optionKey
			});
		},
		showDisclaimer() {
			// ADHOC METHOD TO SHOW A DISCLAIMER. COULD BE EXPANDED TO BE CONTROLLED VIA MATRIX
			if (this.truckModel == "M2 106 Plus" && this.optionKey == "engine_isl9") {
				return "*Not Available with M2 106 Plus in Canada";
			}
			if (this.truckModel == "M2 106 Plus" && (this.optionKey == "acc_dae" || this.optionKey == "acc_dae_none")) {
				return "*ACC availability is limited based on Engine";
			}
        }
	},
	created(){
		localize().then( local => {
			this.local = local;
			// this.tags = {
			// 	'DD13®': {
			// 		default: local('400 HP | 1750 lb-ft'),
			// 		[local('None')]: local('350-505 HP | 1250-1850 lb-ft')
			// 	},
			// 	'DD15®': {
			// 		default: local('400 HP | 1750 lb-ft'),
			// 		[local('None')]: local('400-505 HP | 1550-1750 lb-ft')
			// 	},
			// 	'DD16®': {
			// 		default: local('500-600 HP | 1850-2050 LB-FT')
			// 	},
			// }
		} );
	}
}


Vue.component('item-card',options);